import React, { useState } from 'react'
import {
    useHistory
} from 'react-router-dom';
import GlobalEvent from 'js-events-listener'
import { Dots } from "react-activity";
import "react-activity/dist/Dots.css";

import { DELETE_LOCATION_MODAL_KEY, LOCATIONS_SLUG, TOGGLE_MODAL_KEY } from '../routes'
import { deleteLocation } from '../api'
import { Button } from '.'
import { NAVY, RED } from '../theme'

export const DeleteLocationAlert = (props) => {
    const [activityActive, toggleActivity] = useState(false)
    const history = useHistory()
    const { location } = props

    function onDisableAlert() {
        GlobalEvent.emit(TOGGLE_MODAL_KEY, {
            active: false,
            modalType: DELETE_LOCATION_MODAL_KEY
        })
    }

    async function _onDeleteLocationAlert() {
        try {
            toggleActivity(true)

            const res = await deleteLocation(location.id)

            history.replace(LOCATIONS_SLUG)
            onDisableAlert(false)

        } catch (e) {
            toggleActivity(false)

            console.log(e)
        }
    }

    return (
        <div style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, zIndex: 1000, backgroundColor: 'rgba(220,220,220, .5)' }} >
            <div className="login distribute distribute-center" style={{ marginTop: '0vh', }}>
                <div className="login-container distribute distribute-center">
                    <div class="F5 navy" style={{ alignSelf: 'center', marginBottom: '15px', marginTop: '30px' }}>Are you sure you want to delete {location.name}?</div>

                    {(!activityActive)
                        ? <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', width: '100%' }}>
                            <Button
                                width={'100%'}
                                text={"No"}
                                backgroundColor={NAVY}
                                textColor={'white'}
                                onClick={onDisableAlert} />

                            <div style={{ width: '15%' }} />

                            <Button
                                width={'100%'}
                                text={"Yes"}
                                backgroundColor={RED}
                                onClick={_onDeleteLocationAlert}
                                textColor={'white'}
                            />
                        </div>
                        : <Dots color={NAVY}/>
                    }


                </div>
            </div>
        </div>
    )
}